import api from './apiClient.js'

class EmailNotificationService {
    // Get all email notifications with pagination and filtering
    async getEmailNotifications(params = {}) {
        try {
            // const response = await api.get('/admin/email-notifications', { params })
            const response = await api.get('/admin/email-notifications')
            return response.data.data || response.data
        } catch (error) {
            throw this.handleError(error)
        }
    }

    // Get email notification by ID
    async getEmailNotificationById(id) {
        try {
            const response = await api.get(`/admin/email-notifications/${id}`)
            return response.data.data || response.data
        } catch (error) {
            throw this.handleError(error)
        }
    }

    // Create new email notification
    async createEmailNotification(data) {
        try {
            const response = await api.post('/admin/email-notifications', data)
            return response.data.data || response.data
        } catch (error) {
            throw this.handleError(error)
        }
    }

    // Update email notification
    async updateEmailNotification(id, data) {
        try {
            const response = await api.put(`/admin/email-notifications/${id}`, data)
            return response.data.data || response.data
        } catch (error) {
            throw this.handleError(error)
        }
    }

    // Delete email notification
    async deleteEmailNotification(id) {
        try {
            const response = await api.delete(`/admin/email-notifications/${id}`)
            return response.data.data || response.data
        } catch (error) {
            throw this.handleError(error)
        }
    }

    // Toggle email notification status
    async toggleEmailNotificationStatus(id, status) {
        try {
            const response = await api.patch(`/admin/email-notifications/${id}/toggle-status`, { status })
            return response.data.data || response.data
        } catch (error) {
            throw this.handleError(error)
        }
    }

    // Get email statistics
    async getEmailStatistics() {
        try {
            const response = await api.get('/admin/email-notifications/statistics')
            return response.data.data || response.data
        } catch (error) {
            throw this.handleError(error)
        }
    }

    // Get email types for dropdown
    async getEmailTypes() {
        try {
            const response = await api.get('/admin/email-notifications/types')
            return response.data.data || response.data
        } catch (error) {
            throw this.handleError(error)
        }
    }

    // Test email configuration
    async testEmailConfiguration(email) {
        try {
            const response = await api.post('/admin/email-notifications/test-configuration', { email })
            return response.data.data || response.data
        } catch (error) {
            throw this.handleError(error)
        }
    }

    // Handle API errors
    handleError(error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            const { data, status } = error.response

            if (status === 401) {
                return new Error('Unauthorized access. Please login again.')
            }

            if (status === 403) {
                return new Error('You do not have permission to perform this action.')
            }

            if (status === 404) {
                return new Error('Resource not found.')
            }

            if (status === 422) {
                // Validation errors
                const validationErrors = data?.errors || data?.message
                return new Error(validationErrors || 'Validation failed.')
            }

            if (status >= 500) {
                return new Error('Server error. Please try again later.')
            }

            // Return the error message from the server
            return new Error(data?.message || 'An error occurred.')
        }

        if (error.request) {
            // The request was made but no response was received
            return new Error('Network error. Please check your connection.')
        }

        // Something happened in setting up the request
        return new Error(error.message || 'An unexpected error occurred.')
    }
}

export const emailNotificationService = new EmailNotificationService()
export default emailNotificationService